import React, { FunctionComponent, useState } from "react";
import { FormControl, MenuItem, Select, SelectChangeEvent, InputLabel } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next";

import regions from "./regions";

export const RegionSelect: FunctionComponent<any> = () => {

    const [region, setRegion] = useState("");
    const classes = useStyles();
    const { t } = useTranslation();

    const handleChange = (event: SelectChangeEvent) => {
        setRegion(event.target.value as string);
    }


    return (
        <FormControl className={classes.select}>
            <InputLabel id="region-select-label">{t('regionLabel')}</InputLabel>
            <Select
                id="region-select"
                labelId="region-select-label"
                name="region"
                required
                value={region}
                onChange={handleChange}
            >
                {regions.map(u => <MenuItem key={u} value={u}>{u}</MenuItem>)}
            </Select>
        </FormControl>
    );
}

const useStyles = makeStyles({
    select: {
        width: "100%",
        maxWidth: "30rem",
        marginTop: "1rem",
        marginBottom: "1rem"
    },
    helperText: {
        color: "#000"
    }
})